export default __webpack_public_path__ + "static/media/Bloodytilesets(editrecolourbyCvrtis).1448356728.0a549c63.png";